<template>
  <div id="warning-record">
    <div class="page-header">
      报警信息
      <!-- <span>
        记录列表(
        <strong>{{ tableList.length }}</strong>)
      </span> -->
    </div>

    <div class="module-search">
      <span>处理状态:</span>
      <el-select v-model="search.handleState" clearable placeholder="请选择状态" class="status-select">
        <el-option
          v-for="item in deviceStatus"
          :key="item.value"
          :label="item.code"
          :value="item.value"
        />
      </el-select>

      <span style="margin-left: 40px;">报警日期:</span>
      <el-date-picker
        v-model="search.time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
      />

      <el-button v-if="isAdmin" class="link-btn" type="primary" @click="linkDevice">
        一键联动设备
      </el-button>
      <el-button class="search-btn" type="primary" :disabled="tableLoading" @click="handleSearch">
        查询
      </el-button>
    </div>

    <div class="table-box">
      <el-table
        v-loading="tableLoading"
        :data="tableList"
        :show-overflow-tooltip="true"
        class="module-main"
        style="width: 100%"
        header-row-class-name="table-header"
        row-class-name="table-row"
      >
        <el-table-column prop="warningTime" label="报警时间" align="center" width="160" />
        <el-table-column show-overflow-tooltip prop="info.name4Company" label="设备名称" align="center" />
        <el-table-column prop="type" label="报警级别" align="center" />
        <el-table-column show-overflow-tooltip prop="handleRealname" label="处理人" align="center" />
        <el-table-column prop="handleTime" label="处理时间" align="center" width="160" />
        <el-table-column show-overflow-tooltip prop="result" label="处理意见" align="center" />
        <!-- <el-table-column show-overflow-tooltip prop="info.code" label="设备编码" align="center" /> -->
        <!-- <el-table-column show-overflow-tooltip prop="info.installPosition" label="安装位置" align="center" /> -->
        <!-- <el-table-column prop="installTime" label="安装时间" align="center" /> -->
        <el-table-column label="运行状态" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.info.online ? 'green' : 'red'">
              {{ scope.row.info.online ? '正常' : '离线' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="处理状态" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.handleState === 0 ? 'red' : scope.row.handleState === 1 ? 'yellow': 'green'">
              {{ scope.row.handleState === 0 ? '未处置' : scope.row.handleState === 1 ? '处置中': '处置完成' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="table-detail" @click="handleClickDetail(scope.row.id)">详情</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageIndex"
        background
        class="pagination"
        layout="prev, pager, next"
        @current-change="changePageData"
      />
    </div>

    <el-dialog
      :visible.sync="addUserDialogVisibility"
      custom-class="add-user-dialog"
      title="报警详情"
      width="960px"
      @closed="handleAddUserDialogClosed"
    >
      <div class="input-info">
        <span class="title"><span>*</span>报警时间:</span>
        <el-input v-model="addUserDialogData.warningTime" disabled placeholder="无" />
      </div>
      <!-- <div class="input-info">
        <span class='title'><span>*</span>安装时间:</span>
        <el-input disabled v-model="addUserDialogData.info.installTime" placeholder="无" />
      </div> -->
      <div class="input-info">
        <span class="title"><span>*</span>设备名称:</span>
        <el-input v-model="addUserDialogData.info.name4Company" disabled placeholder="无" />
      </div>
      <!-- <div class="input-info" :title='addUserDialogData.info.code'>
        <span class='title'><span>*</span>设备编码:</span>
        <el-input disabled v-model="addUserDialogData.info.code" placeholder="无" />
      </div> -->
      <!-- <div class="input-info">
        <span class='title'><span>*</span>品牌:</span>
        <el-input disabled v-model="addUserDialogData.info.brand" placeholder="无" />
      </div> -->
      <!-- <div class="input-info">
        <span class='title'><span>*</span>GUID:</span>
        <el-input disabled v-model="addUserDialogData.info.guid" placeholder="无" />
      </div> -->
      <div class="input-info">
        <span class="title"><span>*</span>IMEI:</span>
        <el-input v-model="addUserDialogData.info.imei" disabled placeholder="无" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>安装位置:</span>
        <el-input v-model="addUserDialogData.info.installPosition" disabled placeholder="无" />
      </div>
      <!-- <div class="input-info">
        <span class='title'><span>*</span>MAC:</span>
        <el-input disabled v-model="addUserDialogData.info.mac" placeholder="无" />
      </div> -->
      <div class="input-info">
        <span class="title"><span>*</span>处理人:</span>
        <el-input v-model="addUserDialogData.handleRealname" disabled placeholder="无" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>处理时间:</span>
        <el-input v-model="addUserDialogData.handleTime" disabled placeholder="无" />
      </div>
      <div class="input-infos">
        <span class="title"><span>*</span>备注:</span>
        <el-input
          v-model="addUserDialogData.remarks"
          class="remark-input"
          disabled
          type="textarea"
          :rows="2"
          placeholder="无"
        >
        </el-input>
      </div>
      <div class="input-infos">
        <span class="title"><span>*</span>现场图片:</span>
        <div class="img-list">
          <!-- <img :src="item" alt="" v-for='(item, index) in addUserDialogData.info.installPics' :key='index'> -->
          <el-image
            v-for="(item, index) in addUserDialogData.info.installPics"
            :key="index"
            :src="item"
            :preview-src-list="addUserDialogData.info.installPics"
            style="width: 150px;height:150px;marginRight:10px;"
          ></el-image>
          <img v-if="!addUserDialogData.info.installPics.length" class="nopic" src="/static/img/common/noImage.png">
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button class="certain-btn" type="primary">确定添加</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/objectUtil'

export default {
  name: 'WarningRecord',
  data () {
    return {
      isAdmin: false,
      tableLoading: true,
      // 请求接口
      path: {
        listPath: '/api/device-warning-info/list',
      },
      search: {
        handleState: '',
        time: '',
      },
      deviceStatus: [
        { value: 0, code: '未处置' },
        { value: 1, code: '处置中' },
        { value: 2, code: '处置完成' },
      ],
      statusList: [],
      // 列表样式
      tableList: [
        // {
        //   name4Company: '设备名称',
        //   code: '设备编码',
        //   installPosition: '安装位置',
        //   installTime: '安装时间',
        //   online: '运行状态',
        //   status: '处理状态',
        // }
      ],
      addUserDialogVisibility: false,
      // 分页数据
      pagination: {
        // 一共多少页
        pageCount: 1,
        // 第几页
        pageIndex: 1,
        // 一页显示多少个
        pageSize: 10,
        // 总个数
        total: 0,
      },
      addUserDialogData: {
        warningTime: '',
        handleRealname: '',
        handleTime: '',
        info: {
          // installTime: '',
          name4Company: '',
          code: '',
          brand: '',
          // guid: '',
          imei: '',
          // mac: '',
          installPosition: '',
          installPics: '',
        },
      },
    }
  },
  mounted () {
    let { pagination: { pageIndex, pageSize } } = this
    this.getListReq({ pageIndex, pageSize })
    this.isAdmin = this.$store.state.rolename === '超级管理员'
  },
  methods: {
    // 一键联动设备, 因演示项目新增接口
    linkDevice () {
      this.$http.get('/api/ctg/open/device/linkage').then(res => {
        console.log('res', res)
      })
    },

    getListReq (params) {
      this.tableLoading = true
      let { $http, path: { listPath } } = this

      $http.get(listPath, params).then(res => {
        this.tableLoading = false
        if (res.code === 'success') {
          let { list, pageCount, total } = res.data
          let listTemp = list.map(val => {
            val.warningTime = val.warningTime && formatDateTime(new Date(val.warningTime), 'yyyy-MM-dd HH:mm:ss')
            val.handleTime = val.handleTime && formatDateTime(new Date(val.handleTime), 'yyyy-MM-dd HH:mm:ss')
            // val.installTime = formatDateTime(new Date(val.info.installTime), 'yyyy-MM-dd HH:mm:ss')
            return val
          })
          this.tableList = listTemp
          this.pagination.pageCount = pageCount
          this.pagination.total = total
        }
      })
    },
    changePageData (e) {
      let { handleState, time } = this.search

      let { pagination: { pageSize } } = this

      let startTime = (time && time.length >= 2) ? `${time[0]}` : ''
      let endTime = (time && time.length >= 2) ? `${time[1]}` : ''
      // let startTime = (time && time.length >= 2) ? `${time[0]} 00:00:00` : ''
      // let endTime = (time && time.length >= 2) ? `${time[1]} 23:59:59` : ''

      this.getListReq({ pageIndex: e, pageSize, handleState, startTime, endTime })
    },
    handleSearch () {
      let { handleState, time } = this.search
      let { pagination: { pageIndex, pageSize } } = this

      let startTime = (time && time.length >= 2) ? `${time[0]}` : ''
      let endTime = (time && time.length >= 2) ? `${time[1]}` : ''

      this.getListReq({ pageIndex, pageSize, handleState, startTime, endTime })
    },
    handleAddUserDialogClosed () {
      this.addUserDialogVisibility = false
    },
    handleClickDetail (id) {
      let loadObj = this.$loading({ target: document.querySelector('.add-user-dialog') })

      this.addUserDialogVisibility = true

      this.$http.get('/api/device-warning-info/show', { id }).then(res => {
        loadObj.close()
        if (res.code === 'success') {
          let data = res.data
          data.warningTime = data.warningTime && formatDateTime(new Date(data.warningTime), 'yyyy-MM-dd HH:mm:ss')
          data.handleTime = data.handleTime && formatDateTime(new Date(data.handleTime), 'yyyy-MM-dd HH:mm:ss')
          // data.info.installTime = data.info.installTime && formatDateTime(new Date(data.info.installTime), 'yyyy-MM-dd HH:mm:ss')
          data.info.installPics = data.info.installPics ? data.info.installPics.split(',') : []
          this.addUserDialogData = data
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
#warning-record {
  width: 100%;
  min-height: 790px;
  // padding-top: 20px;
  background-color: #fff;
  border: 1px solid #EBEEF0;

  >div {
    width: 95%;
    margin: 0 auto;
  }
  .page-header {
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
    color: #000;

    span {
      font-weight: normal;
      color: #f38226;
    }
  }

  .module-search {
    margin-top: 10px;
    span {
      margin-right: 5px;
      font-size: 14px;
      color: #666;
    }

    /deep/ .el-select {
      width: 90px;
    }

    /deep/ .el-input {
      input {
        padding-right: 0px;

        &::-webkit-input-placeholder {
          font-size: 14px;
        }
      }
    }

    .status-select {
      width: 149px;

      /deep/ .el-input__inner {
        height: 36px;
        border-radius: 2px;
        font-size: 14px;
        color: #333;
      }
    }

    .content-input {
      width: 280px;
      margin-left: 50px;

      /deep/ .el-input-group__prepend {
        border-radius: 2px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        .el-input__inner {
          width: 80px;
          height: 36px;
          border-radius: 2px !important;
        }
      }

      /deep/ .el-input__inner:nth-child(2) {
        width: 200px;
        height: 36px;
        border-radius: 2px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }

    .link-btn {
      float: right;
      margin-left: 20px;
    }

    /deep/ .search-btn {
      float: right;
      // padding: 10px 25px;
      // border-radius: 3px;
      // margin-left: 50px;
      // border: 1px solid #5294d6;
      // color: #5294d6;
      // background: #fff;

      // &:hover {
      //   background-color: fade(#5294d6, 10);
      //   color: #5294d6;
      // }
    }
    .add-btn {
      float: right;
    }
  }

  .table-box {
    margin-top: 20px;
    .module-main {
      .table-detail {
        color: #409EFF;
        margin-right: 10px;
        cursor: pointer;
      }
      .delete-tag {
        color: #f06366;
        text-decoration: underline;
        margin-left: 3px;
        cursor: pointer;
      }

      .green {
        color: #4dd292;
      }

      .red {
        color: #f06366;
      }

      .yellow {
        color: #E6A23C;
      }

      .blue-btn {
        width: 72px;
        background-color: #5294d6;
        // margin-left: 5px;

        &:hover {
          background-color: fade(#5294d6, 85);
        }
      }

      .red-btn {
        background-color: #f06366;
        margin-left: 5px;

        &:hover {
          background-color: fade(#f06366, 80);
        }
      }

      .look-details {
        color: #5294d6;
        text-decoration: underline;
        cursor: pointer;
      }

      /deep/ .table-header {
        color: #333;
        font-size: 14px;
        font-weight: bold;

        th {
          // height: 40px !important;
          // padding: 0px;
          text-align: center !important;
          line-height: 25px;
          background-color: #e9f0fa;
        }
      }

      /deep/ .table-row {
        color: #333;
        font-size: 14px;

        .numbering {
          color: #5294d6;
          text-decoration: underline;
          cursor: pointer;
        }

        td {
          padding: 12px 0;
        }
      }
    }
    .table-delete {
      color: #F56C6C;
    }
    .pagination {
      padding: 31px 0;
      height: 32px;
      text-align: center;
      font-weight: normal;

      /deep/ .number {
        background-color: #fff;
        border: 1px solid #e1e1e1;
        padding: 2px 5px;
        height: 32px;
        min-width: 32px;
      }

      /deep/ .active {
        border: none;
        background-color: #4078dd;
      }

      /deep/ .btn-prev {
        width: 32px;
        height: 32px;
      }

      /deep/ .btn-next {
        width: 32px;
        height: 32px;
      }

      /deep/ .more {
        width: 32px;
        height: 32px;
        line-height: 35px;
      }
    }
  }
  /deep/ .add-user-dialog,
  /deep/ .modify-user-data-dialog {
    .el-dialog__header {
      height: 40px;
      padding: 0px;
      line-height: 40px;
      text-indent: 20px;
      background-color: #214f88;
    }

    .el-dialog__headerbtn {
      margin-top: -6px;
    }

    .el-dialog__header .el-dialog__title {
      font-size: 16px;
      color: #fff;
    }

    .el-dialog__body {
      padding: 30px 20px 30px 55px;
      min-height: 485px;
    }

    .input-infos {
      margin-bottom: 20px;
      .remark-input {
        // border: 1px solid red;
        width: 640px;
      }
      .title {
        text-align: right;
        display: inline-block;
        width: 90px;
        margin-right: 10px;
        vertical-align: top;
        & > span {
          color: red;
          display: none;
        }
      }
      .img-list {
        display: inline-block;
        // img {
        //   width: 150px;
        //   height: 150px;
        //   margin-right: 10px;
        // }
        .nopic {
          width: 80px;
          height: 80px;
          border: 1px dashed #ccc;
          padding: 35px;
        }
      }
    }
    .input-info {
      display: inline-block;
      margin-bottom: 20px;
      width: 400px;

      .title {
        text-align: right;
        display: inline-block;
        width: 90px;
        // margin-right: 14px;

        & > span {
          color: red;
          margin-right: 3px;
          display: none;
        }
      }

      .el-input {
        width: 240px;
        margin-left: 10px;

        input {
          height: 36px;
        }
      }

      .el-cascader {
        .el-cascader__label {
          text-indent: 13px;
        }
      }

      &.long {
        box-sizing: border-box;
        clear: both;
        width: 100%;
        margin-left: 0px;
        padding-right: 85px;

        .el-input {
          width: 720px;
        }
      }

      .info-content {
        color: #c4c3c3;
        font-size: 12px;
      }

      .el-select__tags {
        text-align: left;
        padding-left: 15px;
      }
    }

    .radio-info {
      float: left;
      margin-bottom: 13px;
      height: 36px;
      line-height: 36px;
      width: 320px;

      &:nth-child(3) {
        margin-left: 33px;
      }

      &:nth-child(4) {
        margin-left: 160px;
      }

      .el-radio-group {
        margin-left: 10px;
      }
    }
  }
}
</style>
